// extracted by mini-css-extract-plugin
module.exports = {"input":"InputUser_input__17ZNw"};